import type {SerializedError} from '@reduxjs/toolkit';
import {
  type FetchBaseQueryError,
  QueryStatus,
} from '@reduxjs/toolkit/query/react';
import type {DataLoadStatus} from 'api/types';
import {mapRtkErrorToHttpError} from './mapRtkErrorToHttpError';

export const mapRtkToDataLoad = <T>(
  status: QueryStatus,
  data?: T,
  error?: FetchBaseQueryError | SerializedError,
): DataLoadStatus<T> => {
  if (status === QueryStatus.pending) {
    return {status: 'Loading', data};
  }

  if (error) {
    return {
      status: 'Failed',
      error: mapRtkErrorToHttpError(error),
    };
  }

  if (data) {
    return {status: 'Loaded', data};
  }

  return {status: 'NotLoaded', data: undefined};
};
